module.exports = __webpack_public_path__ + "942777b0ebd493ab1985ff7077cd7697.jpg";